<template>
  <div class="flex items-start justify-start flex-col gap-3 min-h-[250px]">
    <h3 class="font-medium leading-6 text-gray-700 text-md dark:text-dark-body-text">
      {{ $t("You can here make data sources read only to prevent updates to linked data sources") }}
    </h3>
    <div class="text-gray-700">
      {{ $t("Mapped Data Sources") }}:
    </div>
    <div v-for="data_source in current_metric.data_sources" :key="data_source.origin">
      <div class="flex items-center justify-center text-base font-medium text-gray-700 capitalize dark:text-white">
        {{ data_source.origin.replace("ml.", "") }}
        <div class="float-right px-2">
          <Switch
            v-model="data_source.is_updates_to_origin_disabled"
            :disabled="data_source.origin == 'rs_datahub'"
            :class="[
              !data_source.is_updates_to_origin_disabled ? 'bg-blue' : 'bg-gray-200',
              'relative inline-flex flex-shrink-0 h-7 w-12 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue'
            ]">
            <span
              aria-hidden="true"
              :class="[
                !data_source.is_updates_to_origin_disabled && $store.state.portfolio.ui_options?.language == 'ar'
                  ? '-translate-x-5'
                  : !data_source.is_updates_to_origin_disabled
                    ? 'translate-x-5'
                    : 'translate-x-0',
                'pointer-events-none inline-block h-6 w-6 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200'
              ]" />
          </Switch>
        </div>
        <span v-if="data_source.origin == 'rs_datahub'"
              class="text-sm leading-3 text-gray-500">{{ $t("Updates Disabled") }} <span class="font-light text-gray-800">{{ $t("(ReadOnly Data Source)") }} </span></span>
        <span v-else-if="!data_source.is_updates_to_origin_disabled"
              class="text-sm leading-3 text-gray-500">{{ $t("Updates Enabled") }}
          <span class="font-light text-gray-800">({{ $t("any change on Metric value") }} <span class="!font-bold">{{ $t("will") }} </span> {{ $t("reflect on your") }}
            {{ data_source.origin }})
          </span></span>
        <span v-else
              class="text-sm leading-3 text-gray-500">{{ $t("Updates Disabled") }}
          <span class="font-light text-gray-800">({{ $t("ReadOnly, Any change") }} <span class="!font-bold">{{ $t("will not") }} </span>{{ $t("reflect on your") }}
            {{ data_source.origin }})
          </span></span>
      </div>
    </div>
  </div>
</template>

<script>
import { Switch } from "@headlessui/vue"
import { utils } from "@/store/helpers"

export default {
  components: {
    Switch
  },
  props: {
    metric: {
      type: Object,
      required: true
    }
  },
  emits: ["update:modelValue", "update"],
  data() {
    return {
      current_metric: null
    }
  },
  watch: {
    current_metric: {
      deep: true,
      handler() {
        if (this.current_metric) {
          this.$emit("update", this.current_metric)
        }
      }
    }
  },
  created() {
    this.current_metric = utils.clone(this.metric)
  }
}
</script>
